import React from "react";
import { Link } from "react-router";
import alasql from "alasql";
import SearchField from "../../common/searchField";
import DataTable from "react-data-table-component";
import { interpolateRgbBasis } from "d3";

const MyPortfolioTable = ({
  data,
  searchFieldInput,
  searchHandler,
  clearSearchFieldHandler,
  filterByName,
}) => {
  var sortedData = alasql("SELECT * FROM ? ORDER BY scenario_id", [data]);

  // filtering empty name and type
  let filtered = sortedData.filter(filterByName);
  // filter searched data
  let NewSortedData = filtered.filter((d) => {
    if (searchFieldInput == null) {
      return filtered;
    } else {
      return (
        d.scenario_name.toUpperCase().indexOf(searchFieldInput) !== -1 ||
        d.benchmark.toUpperCase().indexOf(searchFieldInput) !== -1 ||
        d.scenario_id.toString().indexOf(searchFieldInput) !== -1
      );
    }
  });
  const growth = (yrs, i) => {
    let p = 10000;
    let x = p * Math.pow(1 + i, yrs);
    return (x / 1000).toFixed(2);
  };

  const PortfolioName = ({ row }) => (
    <Link
      to={{
        pathname: "/dashboard",
        state: {
          foo: row.scenario_id,
          heading: row.scenario_name,
          type: row.type,
          subHeading: row.benchmark_name,
          benchmark: row.benchmark,
          benchmark_name: row.benchmark_name,
        },
      }}
      className="LinkDisableStyle"
    >
      <div>{row.scenario_name.toUpperCase()}</div>
    </Link>
  );

  const Portfolio = ({ row }) => (
    <div>{(row.fund_annualized_return * 100).toFixed(2)}</div>
  );
  const Benchmark = ({ row }) => (
    <div>{(row.bm_annualized_return * 100).toFixed(2)}</div>
  );
  const FiveYear = ({ row }) => (
    <div>{growth(5, row.fund_annualized_return)}</div>
  );
  const TenYear = ({ row }) => (
    <div>{growth(10, row.fund_annualized_return)}</div>
  );
  const FifteenYear = ({ row }) => (
    <div>{growth(20, row.fund_annualized_return)}</div>
  );

  const columns = [
    {
      name: "PORTFOLIO ID",
      selector: "scenario_id",
      sortable: true,
      width: "100px",
    },
    {
      name: "PORTFOLIO TYPE",
      selector: "type",
      sortable: true,
    },
    {
      name: "PORTFOLIO NAME",
      selector: "scenario_name",
      sortable: true,
      cell: (row) => <PortfolioName row={row} />,
      width: "300px",
    },
    {
      name: "PORTFOLIO",
      selector: "fund_annualized_return",
      sortable: true,
      width: "100px",
      cell: (row) => <Portfolio row={row} />,
    },
    {
      name: "BENCHMARK",
      selector: "bm_annualized_return",
      sortable: true,
      width: "100px",
      cell: (row) => <Benchmark row={row} />,
    },
    {
      name: "5Y",
      selector: "fund_annualized_return",
      sortable: true,
      width: "100px",
      cell: (row) => <FiveYear row={row} />,
    },
    {
      name: "10Y",
      selector: "fund_annualized_return",
      sortable: true,
      width: "100px",
      cell: (row) => <TenYear row={row} />,
    },
    {
      name: "20Y",
      selector: "fund_annualized_return",
      sortable: true,
      width: "100px",
      cell: (row) => <FifteenYear row={row} />,
    },
    {
      name: "BENCHMARK",
      selector: "benchmark",
      sortable: true,
      grow: 2,
    },
  ];

  const customStyles = {
    table: {
      style: {
        borderBottomStyle: "solid",
        borderBottomWidth: "1px",
        borderBottomColor: "#d4d7de",
      },
    },
    header: {
      style: {
        display: "none",
      },
    },
    headCells: {
      style: {
        fontWeight: "bold",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#d4d7de",
      },
    },
    rows: {
      style: {
        minHeight: "35px",
        "&:nth-child(even)": {
          background: "#d4d7de73",
        },
      },
    },
  };
  return (
    <div className="page-body">
      <div className="step clearfix transition-2s">
        <SearchField
          searchFieldInput={searchFieldInput}
          searchHandler={searchHandler}
          clearHandler={clearSearchFieldHandler}
        />
        <div style={{ overflow: "auto" }}>
          <table
            className="table bordered"
            style={{
              width: "100%",
              marginBottom: "1px",
              color: "rgba(0, 0, 0, 0.8)",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#d4d7de" }}>
                <th style={{ width: "100px" }}></th>
                <th style={{ width: "100px" }}></th>
                <th></th>
                <th
                  colSpan={2}
                  style={{
                    width: "200px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  SINCE INCEPTION (%)
                </th>
                <th
                  colSpan={3}
                  style={{
                    width: "180px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  HYP.GROWTH OF 10K
                </th>
                <th></th>
              </tr>
            </thead>
          </table>
        </div>

        <DataTable
          data={NewSortedData}
          columns={columns}
          customStyles={customStyles}
        />
      </div>
    </div>
  );
};

export default MyPortfolioTable;



// WEBPACK FOOTER //
// ./src/components/pages/MyPortfolio/myPortfolioTable.jsx